import * as Sentry from '@sentry/react'
import type { Router } from '@tanstack/react-router'

import { basePathInfo, isProd } from '@/constants/config.constants'
import { credentials } from '@/constants/credentials.constants'
import { reactAppVersion } from '@/constants/platform.constants'

export const setupSentry = (router: Router<any, 'never', true>) => {
  const sentryConfig: Sentry.BrowserOptions = {
    dsn: credentials.sentryDNS,
    // tunnel: '/tunnel',
    release: `app@${reactAppVersion}`,
    environment: isProd ? 'production' : basePathInfo || 'dev-default',
    normalizeDepth: 10,
    attachStacktrace: true,
    ignoreErrors: [
      /500/,
      /401/,
      /403/,
      /Network error/,
      /Network Error/,
      /NetworkError/,
      /authenticate/,
    ],
    beforeSend(event) {
      if ('user' in event && event.user) {
        // Don't send user's email address
        delete event.user.email
      }

      return event
    },
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
    tracesSampleRate: 0.05,
    sendDefaultPii: true,
    enabled: import.meta.env.PROD,
  }

  Sentry.init(sentryConfig)
}
